import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

import { ConfirmDialog } from '@/components/molecules/ConfirmDialog';
import { type ClientLicense, useDeleteClientLicense } from '@/domain/licenses';

interface DeleteLicenseModalProps {
    onClose: () => void;
    selectedLicense: ClientLicense | null;
}

function DeleteLicenseModal({ onClose, selectedLicense }: DeleteLicenseModalProps) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const deleteLicense = useDeleteClientLicense();

    const handleConfirm = async () => {
        if (!selectedLicense) return;
        try {
            await deleteLicense.mutateAsync({ id: selectedLicense.id });
        } finally {
            queryClient.invalidateQueries();
        }
    };

    return (
        <ConfirmDialog
            isOpen={true}
            onClose={onClose}
            title={t('internal.clientLicense.deleteTitle')}
            message={t('internal.clientLicense.confirmDeleteNamed', {
                name: selectedLicense?.name ?? '',
            })}
            confirmLabel={t('common.actions.delete')}
            errorFallback={t('internal.clientLicense.deleteFailed')}
            onConfirm={handleConfirm}
        />
    );
}

export default DeleteLicenseModal;
